import { createLogic } from 'redux-logic';
// helpers/constants
import * as GC from '../../constants';
// feature new-import
import * as A from './actions';
//////////////////////////////////////////////////

const handleLocationChangeLogic = createLogic({
  type: GC.LOCATION_CHANGE_ACTION,
  validate({ getState, action }, allow) {
    allow(action);
  },
  process({ getState, action }, dispatch, done) {
    dispatch(A.setInitialState());
    done();
  },
});

export default [handleLocationChangeLogic];
